import 'react-app-polyfill/stable';
import dva from 'dva';
import leaveMsg from "./models/leaveMsg";
import './services/base';
import './index.css';
const createHistory = require("history").createBrowserHistory;

window.urlObject = {};
window.location.search.replace(/([^?&=]+)=([^&]+)/g,(_,k,v)=>window.urlObject[k]=v);
// 1. Initialize
const app = dva({
  history: createHistory()
});

// 2. Plugins
// app.use(require());

// 3. Model
app.model(leaveMsg);
app.model(require('./models/app').default);
app.model(require('./models/locale').default);

// 4. Router
app.router(require('./router').default);

// 5. Start

app.start('#root');
